export default __webpack_public_path__ + "static/media/mechzVert1Png2.98890dd5.png";